export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./certificates.vue?vue&type=template&id=ef298d94&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/certificates.vue?vue&type=template&id=ef298d94&
// module id = 1624
// module chunks = 0